// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { file16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-file': IconFile;
    }
}

/**
 * The icon component for the 'file' icon
 */
export class IconFile extends IconSvg {
    public constructor() {
        super(file16X16);
    }
}

registerIconSvg('icon-file', IconFile);
export const iconFileTag = 'nimble-icon-file';
